import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaGraduationCap, FaCheckCircle, FaChartLine, FaBell } from 'react-icons/fa';
import '../../../../assets/css/general/footer/FeaturesDetail.css';

const NGOPortal = () => {
  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        <div className="feature-header">
          <div className="feature-icon-large">
            <FaGraduationCap />
          </div>
          <h1 className="feature-title">NGO Portal</h1>
          <p className="feature-subtitle">
            Manage student cases, verify requests, and connect donors with deserving students
          </p>
        </div>

        <div className="feature-content">
          <section className="feature-section">
            <h2>Welcome to Your Portal</h2>
            <p>
              The NGO Portal is your central hub for managing and verifying student support requests.
              From reviewing applications to connecting donors with genuine cases and monitoring
              impact, everything you need to manage support efficiently is available here.
            </p>
          </section>

          <section className="feature-section">
            <h2>Portal Features</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">📋</div>
                <h3>Review Student Requests</h3>
                <p>Access and review student applications submitted for financial assistance.</p>
              </div>
              <div className="step-card">
                <div className="step-number">✅</div>
                <h3>Verify Cases</h3>
                <p>Carefully verify documents and approve genuine student support requests.</p>
              </div>
              <div className="step-card">
                <div className="step-number">🤝</div>
                <h3>Connect with Donors</h3>
                <p>Forward verified cases to donors and help facilitate secure support.</p>
              </div>
              <div className="step-card">
                <div className="step-number">📊</div>
                <h3>Impact Monitoring</h3>
                <p>Track how verified cases are funded and monitor overall support impact.</p>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <h2>Key Benefits</h2>
            <div className="features-list">
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Efficient Case Management</h4>
                  <p>Manage, review, and verify student requests from one centralized dashboard.</p>
                </div>
              </div>
              <div className="feature-item">
                <FaChartLine className="feature-check" />
                <div>
                  <h4>Transparent Workflow</h4>
                  <p>Maintain full transparency while processing and forwarding student cases.</p>
                </div>
              </div>
              <div className="feature-item">
                <FaBell className="feature-check" />
                <div>
                  <h4>Real-time Updates</h4>
                  <p>Receive instant notifications about new applications and donor activity.</p>
                </div>
              </div>
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Secure Data Handling</h4>
                  <p>Safely manage student documents and verification records in one place.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section cta-section">
            <h2>Ready to Access Your Portal?</h2>
            <p>Login or register your NGO to start verifying cases and supporting students today.</p>
            <button className="cta-button">Access Portal</button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default NGOPortal;